import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

const HeaderMenuArrowIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width="7px" height="10px" viewBox="0 0 7 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>路径 6</title>
      <g
        id="页面-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="home-h5-侧拉导航栏" transform="translate(-326.000000, -220.000000)" stroke="#1E2329" strokeWidth="1.5">
          <g id="编组-29" transform="translate(244.000000, 153.000000)">
            <g id="编组-32" transform="translate(0.000000, 62.000000)">
              <polyline
                id="路径-6"
                points="83.4795086 6.08575218 87.4795086 10.113717 83.4795086 14.1518666"
              ></polyline>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </span>
);

export default HeaderMenuArrowIcon;
